import { ColumnType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation } from "react-router";
import DatewiseBreakdownDrawer from "./DailyProgressDigest/DatewiseBreakdownDrawer";

const DailyProgressDigest = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: projectId } = location.state || {};
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(null);

  const columns: ColumnType<any>[] = [
    {
      title: "Date",
      dataIndex: "actualStartDate",
      key: "actualStartDate",
      width: 100,
      render: (text: string, record: any) => (
        <span
          className="inlineTableCellLink"
          id={`date-${record?.id}`}
          onClick={() => handleDateClick(record)}
          style={{ padding: 0 }}
        >
          {text || "N/A"}
        </span>
      ),
    },
    {
      title: "Task Completed",
      dataIndex: "completedTasks",
      key: "completedTasks",
      width: 100,
      render: (text) =>
        text === null || text === undefined || text === "" ? "N/A" : text,
    },
    {
      title: "Pending Tasks",
      dataIndex: "PendingTasks",
      key: "PendingTasks",
      width: 100,
      render: (text) =>
        text === null || text === undefined || text === "" ? "N/A" : text,
    },
    {
      title: "Issues Raised",
      dataIndex: "issuesRaised",
      key: "issuesRaised",
      width: 100,
      render: (text) =>
        text === null || text === undefined || text === "" ? "N/A" : text,
    },
    {
      title: "Delays Reported",
      dataIndex: "DelaysReported",
      key: "DelaysReported",
      width: 100,
      render: (text) =>
        text === null || text === undefined || text === "" ? "N/A" : text,
    },
  ];

  const handleDateClick = (record: any) => {
    setSelectedDate(record);
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setSelectedDate(null);
  };

  useEffect(() => {
    dispatch(
      updateMenuData([
        {
          text: "Daily Progress Digest",
          link: "/pms/daily-progress-digest",
        },
      ])
    );
  }, []);

  return (
    <>
      <Template1
        moduleKey={window.location.pathname}
        columns={columns}
        pageTitle="Daily Progress Digest"
        pageDescription=""
        previousPath={{
          link: "/pms/project/reports",
          state: location.state,
        }}
        filters={{
          defaultFilters: {
            dateRange: {
              title: "Task Actual Start Date",
            },
          },
        }}
      />

      <DatewiseBreakdownDrawer
        visible={drawerVisible}
        selectedDate={selectedDate}
        onClose={handleDrawerClose}
        projectId={projectId}
      />
    </>
  );
};

export default DailyProgressDigest;
